<template>
    <div v-if="open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

        <div class="bg-white w-full max-w-xl rounded-2xl shadow-xl p-8" @click.stop>

            <div class="mb-6">
                <h2 class="text-2xl font-extrabold">Buying Behaviour</h2>
                <p class="text-sm text-slate-500">
                    Help creators understand your influence power
                </p>
            </div>

            <form class="space-y-5" @submit.prevent.stop="submitSegment2">

                <!-- Purchased influencer product -->
                <div>
                    <label class="form-label">Purchased product recommended by influencer?</label>

                    <div class="flex gap-4 mt-1">
                        <label class="radio-card">
                            <input type="radio" value="Yes" v-model="form.purchased" />
                            <span>Yes</span>
                        </label>

                        <label class="radio-card">
                            <input type="radio" value="No" v-model="form.purchased" />
                            <span>No</span>
                        </label>
                    </div>
                </div>

                <!-- Monthly spending -->
                <div>
                    <label class="form-label">Average Monthly Online Spending</label>

                    <div class="grid grid-cols-2 gap-2">

                        <label v-for="i in spendingOptions" :key="i" class="radio-card">
                            <input type="radio" :value="i" v-model="form.spending" />
                            <span>{{i}}</span>
                        </label>

                    </div>
                </div>

                <!-- Spending categories -->
                <div>
                    <label class="form-label">Categories you spend money on</label>

                    <div class="multi-custom">
                        <div v-for="c in categories" :key="c" class="multi-item"
                            :class="{ active: form.categories.includes(c) }" @click="toggleCategory(c)">
                            {{ c }}
                        </div>
                    </div>
                </div>

                <button class="w-full bg-primary text-white py-3 rounded-lg font-bold">
                    Save & Continue
                </button>

            </form>

        </div>
    </div>
</template>

<script>
    import { useToast } from "vue-toastification";

    import { saveSegment2Api } from "@/apis/fanapis";

    export default {

        props: { open: Boolean },

        data() {
            return {
                toast: null,
                form: {
                    purchased: "",
                    spending: "",
                    categories: []
                },

                spendingOptions: [
                    "₹0 – ₹1,000",
                    "₹1,000 – ₹3,000",
                    "₹3,000 – ₹7,000",
                    "₹7,000 – ₹15,000",
                    "₹15,000 – ₹50,000",
                    "₹50,000 +"
                ],

                categories: [
                    "Fashion", "Beauty", "Fitness", "Tech", "Gaming",
                    "Finance", "Travel", "Food", "Luxury", "Education", "Crypto", "Other"
                ]

            }
        },
        mounted() {
            this.toast = useToast();
        },
        methods: {
            toggleCategory(c) {
                if (this.form.categories.includes(c)) {
                    this.form.categories = this.form.categories.filter(i => i !== c);
                } else {
                    if (this.form.categories.length >= 3) {
                        this.toast.error("Max 3 categories allowed");
                        return;
                    }
                    this.form.categories.push(c);
                }
            },
            async submitSegment2() {

                const ldataRaw = sessionStorage.getItem("ldata");
                const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
                const user_id = ldata?.user_id;

                if (!this.form.purchased) {
                    this.toast.error("Select purchase behaviour");
                    return;
                }

                if (!this.form.spending) {
                    this.toast.error("Select spending range");
                    return;
                }

                if (this.form.categories.length == 0) {
                    this.toast.error("Select spending categories");
                    return;
                }

                const res = await saveSegment2Api({

                    user_id: user_id,
                    purchased: this.form.purchased,
                    spending: this.form.spending,
                    categories: JSON.stringify(this.form.categories)

                });

                if (res.status) {
                    this.$emit("submit");
                } else {
                    this.toast.error(res.success);
                }

            }

        }

    }

</script>
<style scoped>
    /* Reduce vertical spacing inside form */
    form.space-y-5>div {
        margin-bottom: 10px;
    }

    /* Header spacing tighter */
    .mb-6 {
        margin-bottom: 14px !important;
    }

    /* Label styling */
    .form-label {
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        color: #64748b;
        margin-bottom: 3px;
        display: block;
        letter-spacing: 0.02em;
    }

    /* Input styling */
    .form-input {
        width: 100%;
        border: 1px solid #e5e7eb;
        padding: 7px 9px;
        border-radius: 8px;
        background: #f8fafc;
        font-size: 13px;
        height: 34px;
    }

    /* Multi select bigger height */
    .form-input[multiple] {
        height: auto;
        min-height: 90px;
        padding: 8px;
    }

    /* Radio option card */
    .radio-card {
        display: flex;
        gap: 6px;
        align-items: center;
        border: 1px solid #e5e7eb;
        padding: 6px 8px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 12px;
        transition: all 0.15s ease;
    }

    /* Hover effect */
    .radio-card:hover {
        border-color: #0f172a;
        background: #f9fafb;
    }

    /* Radio slightly smaller */
    .radio-card input {
        transform: scale(0.9);
    }

    /* Button styling */
    button {
        padding: 10px 14px !important;
        font-size: 14px;
        transition: all .2s ease;
    }

    button:hover {
        transform: translateY(-1px);
    }

    .multi-custom {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 6px;
    }

    .multi-item {
        padding: 6px 10px;
        border-radius: 8px;
        background: #f1f5f9;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        border: 1px solid #e5e7eb;
    }

    .multi-item:hover {
        border-color: #0f172a;
        background: #f9fafb;
    }

    .multi-item.active {
        background: #0f172a;
        color: white;
        border-color: #0f172a;
    }
</style>